<main>
  <div class="bolt-space-bottom-lg">
    <bolt-autocomplete maxoptions="10" mincharacters="3" iconname="search" label="{{label}}" name="searchAddress"
      required optionaltext="hide" (bolt-option-click)="getAddressDetails($event)"
      [value]="selectedAddress"
      (keyup)="setOptions($event)"></bolt-autocomplete>
  </div>
  @if (isError) {
    <bolt-notification>
      {{ errorMessage }}
    </bolt-notification>
  }
  @if (showLoader || isShopLoading) {
    <bolt-waiting-indicator>Please wait while we process your request.</bolt-waiting-indicator>
  }
  @if (completeRepairShopData?.length && !(showLoader || isShopLoading)) {
    <bolt-tabset>
      <bolt-tablabel #bringFocus>Preferred shops</bolt-tablabel>
      <bolt-tabpanel class="bolt-space-inner-wide-lg">
        @for (shop of repairShopsList; track shop) {
          <div class="bolt-row bolt-background-ultralightGray bolt-space-bottom-xs spacing"
            (click)="setShopData(shop)">
            <div class="bolt-col-lg-9 bolt-col-md-8 bolt-col-sm-7 bolt-col-xs-12">
              @if (userTypeValue) {
                <input class="scale-185" type="radio" [(ngModel)]="shopId"
                  [value]="shop.nationwideShopID">
              }
              @if (!userTypeValue) {
                <bolt-icon name="location-filled" color="vibrantBlue"
                class="bolt-space-inner-2xs"></bolt-icon>
              }
              <span class="bolt-subheading-lg bolt-space-inline-left-lg textclass">{{shop.shopName}}</span>
              <div class="bolt-space-inner-sm bolt-space-left-sm">
                <div class="bolt-text-sm text">{{ shop.address }}</div>
                <div class="bolt-text-sm text bolt-space-bottom-2xs">{{ shop.city }}, {{ shop.state }}, {{ shop.zipCode }}</div>
                <a href="tel: {{ shop.phoneNumber }}"> {{ shop.phoneNumber }}</a>
              </div>
            </div>
            <div class="bolt-col-lg-3 bolt-col-md-4 bolt-col-sm-6 bolt-col-xs-12 text-center">
              <div class="bolt-space-bottom-2xs">
                <em>{{ shop.proximateDistance | number: '1.1-2' }} miles away</em>
              </div>
              <div class="bolt-space-bottom-2xs bolt-body-copy-md">
                {{ formatDriveTime(shop.driveTime) }}
              </div>
              <bolt-button type="ghost" (click)="getDirections(shop)">Get directions</bolt-button>
            </div>
          </div>
        }
        @if (!isShopLoading) {
          <div class="pagination-container">
            <nav role="navigation" class="pagination-controls" aria-label="pagination navigation">
              <div class="pagination-icon" [class]="selectedListPage > 0 ? '': 'disabled-pagination-icon'">
                <bolt-icon name="chevron-left" [class]="selectedListPage > 0 ? '' : 'disabled'" title="Previous"
                  (click)="onPageClick(selectedListPage - 1)" size="m" color="blue"
                  id="repairShopOYS_previousIcon"></bolt-icon>
              </div>
              @for (item of paginationCounter(); track item; let i = $index) {
                <p [class]="selectedListPage === i ? 'selected-page' : ''"
                  (click)="onPageClick(i)"
                  id="repairShopOYS_counter{{i+1}}">
                  {{i+1}}
                </p>
              }
              <div class="pagination-icon"
                [class]="selectedListPage != paginationCounter().length - 1 ? '': 'disabled-pagination-icon'">
                <bolt-icon name="chevron-right"
                  [class]="selectedListPage != paginationCounter().length - 1 ? '' : 'disabled'" title="Next"
                  (click)="onPageClick(selectedListPage + 1)" size="m" color="blue"
                  id="repairShopOYS_nextIcon"></bolt-icon>
              </div>
            </nav>
          </div>
        }
      </bolt-tabpanel>
    </bolt-tabset>
  }
</main>
